import SubscriptionForm from './subscription-form';

export default SubscriptionForm;
